import { render } from "./EduRegisterView.vue?vue&type=template&id=f61381dc"
import script from "./EduRegisterView.vue?vue&type=script&lang=js"
export * from "./EduRegisterView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__